import {createSelector} from 'helpers';
import {id} from 'store/common';

export const diary = createSelector(
  [ state => state.diary.index, id ],
  ( index, id ) => index[id],
);
